import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
export function OfferSection() {
  return <section id="comprar" className="bg-sand py-12 sm:py-16" data-id="element-136" data-mp="3lzio6gmatbe">
      <div className="mx-auto max-w-2xl px-5" data-id="element-137" data-mp="8lu783cx76ta">
        <div className="rounded-3xl border border-stone bg-ivory p-6 text-center shadow-[0_30px_70px_-45px_rgba(28,27,25,0.4)] sm:p-9" data-id="element-138" data-mp="ddvetbz589cz">
          <h2 className="font-display text-2xl font-semibold leading-tight text-charcoal sm:text-3xl" data-id="element-139" data-mp="ic6rrvkqizzf">
            MegaPack Wellness Digital Pro™
          </h2>
          <p className="mt-2 font-sans text-sm font-semibold text-charcoal/75 sm:text-base" data-id="element-140" data-mp="re662g4d7pyo">
            6 tomos + 5 bonos
          </p>

          <PriceBlock className="mt-5" size="lg" data-id="element-141" data-mp="wboi4fdoilaw" />

          <div className="mt-5 flex justify-center" data-id="element-142" data-mp="2t59jfd5n3imx">
            <CTAButton className="w-full max-w-[22rem] whitespace-nowrap px-5" data-id="element-143" data-mp="2t6kuzz5btuol" />
          </div>

          <p className="mt-2.5 font-sans text-[0.72rem] text-charcoal/60" data-id="element-144" data-mp="2y55ntdi91c30">
            Acceso inmediato · Garantía 7 días · Pago seguro
          </p>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 border-t border-stone pt-4 font-sans text-[0.7rem] text-charcoal/55" data-id="element-145" data-mp="xws3xwzyvoti">
            <span className="inline-flex items-center gap-1" data-id="element-146" data-mp="sxys090bw5vg">
              <CheckIcon className="h-3.5 w-3.5 text-gold-deep" aria-hidden data-id="element-147" data-mp="owwrzpyl7psf" /> 100% digital
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-148" data-mp="1llbgwptyoprx">💳 Mercado Pago</span>
            <span className="inline-flex items-center gap-1" data-id="element-149" data-mp="1gmroq7oryhr4">🏦 Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}